import { createSlice } from "@reduxjs/toolkit"

export const companySlice = createSlice({
    name: "company",
    initialState: {
        companyList: [],
        countryList: [],
        exportList: [],
        companyDetail: {},
        isFreshData: false,
        totalEntry: 0,
        filterTerm: ''
    },   
    reducers: {
        setCompanyList: (state, action) => {
            state.companyList = action.payload
        },
        setCountryList: (state, action) => {
            state.countryList = action.payload
        },
        setFreshList: (state, action) => {
            state.isFreshData = action.payload
        },
        setExportList: (state, action) => {
            state.exportList = action.payload
        },
        setFilterTerm: (state, action) => {
            state.filterTerm = action.payload
        },
        setTotalEntry: (state, action) => {
            state.totalEntry = action.payload
        },
        setSingleData: (state, action) => {
            state.companyDetail = action.payload
        }
    }
})

export const {
    setCompanyList,
    setFreshList,
    setCountryList,
    setExportList,
    setFilterTerm,
    setSingleData,
    setTotalEntry,
    setFilteredList
} = companySlice.actions

export const selectCompanyList = (state) => state.company.companyList
export const selectFreshData = (state) => state.company.isFreshData
export const selectCountryList = (state) => state.company.countryList
export const selectExportList = (state) => state.company.exportList
export const selectFilterTerm = (state) => state.company.filterTerm
export const selectTotalEntry = (state) => state.company.totalEntry
export const selectCompanyDetail = (state) => state.company.companyDetail

export default companySlice.reducer
